import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap';

import { CheckboxField } from '../../../blocks/edit_blocks';
import Pocket from '../Pocket';

export default function PocketGofCountdown() {
    return (
        <Pocket
            isFlex
            itemsLimit={20}
            endpoint="v2/gof.vkplay.ru/pockets/1/"
            withSingleActive
            requiredLangFields={['title', 'picture']}
            requiredFields={[]}
            renderColumns={({ editItem, deleteItem, handleActive }) => ([
                {
                    Header: 'Активно',
                    sortable: false,
                    accessor: 'id',
                    maxWidth: 100,
                    Cell: (row) => (
                        <ButtonToolbar>
                            <ButtonGroup>
                                <CheckboxField
                                    name={row.row.id}
                                    dataValue="is_active"
                                    label=""
                                    value={row.original.is_active | false}
                                    onChange={handleActive}
                                />
                            </ButtonGroup>
                        </ButtonToolbar>
                    ),
                }, {
                    Header: 'Заголовок',
                    sortable: false,
                    accessor: 'content.ru.title',
                    minWidth: 440,
                }, {
                    Header: '',
                    sortable: false,
                    accessor: 'id',
                    maxWidth: 70,
                    Cell: (row) => (
                        <ButtonToolbar>
                            <ButtonGroup>
                                <Button
                                    size="sm"
                                    variant="link"
                                    data-id={row.row.id}
                                    data-value={row.value}
                                    onClick={editItem}
                                >
                                    <FontAwesomeIcon icon="pencil-alt" />
                                </Button>
                                <Button
                                    size="sm"
                                    variant="link"
                                    data-id={row.row.id}
                                    data-title={row.original.content.ru.title}
                                    data-value={row.value}
                                    onClick={deleteItem}
                                >
                                    <FontAwesomeIcon icon="trash" />
                                </Button>
                            </ButtonGroup>
                        </ButtonToolbar>
                    ),
                },
            ])}
            formFields={[
                {
                    type: 'textarea',
                    name: 'title',
                    label: 'Заголовок',
                    maxLength: 128,
                    textareaRows: 3,
                    isRequired: true,
                    isMultilang: true,
                },
                {
                    type: 'input',
                    name: 'link_label',
                    label: 'Текст ссылки',
                    maxLength: 255,
                    isMultilang: true,
                },
                {
                    type: 'input',
                    name: 'link',
                    label: 'Ссылка',
                    maxLength: 255,
                    isMultilang: true,
                },
                {
                    type: 'date-time',
                    name: 'countdown',
                    label: 'Обратный отсчет',
                },
                {
                    type: 'image',
                    name: 'picture',
                    label: 'Изображение',
                    imageMinSize: '1920x200',
                    isRequired: true,
                    isMultilang: true,
                },
            ]}
        />
    );
}
